import settings from '@/store/modules/auth/user/settings'

const initialState = () => ({
  id: null,
  email: null,
  first_name: null,
  last_name: null,
  provider_user_id: null,
  provided_name: null,
  avatar: null,
  role: null,
  status: null
})

export default {
  namespaced: true,
  state: initialState(),
  mutations: {
    assign(
      state,
      {
        id,
        email,
        provider_user_id,
        first_name,
        last_name,
        provided_name,
        avatar,
        role,
        status
      }
    ) {
      state.id = id
      state.email = email
      state.first_name = first_name
      state.last_name = last_name
      state.provider_user_id = provider_user_id
      state.provided_name = provided_name
      state.avatar = avatar
      state.role = role
      state.status = status
    },
    reset(state) {
      Object.assign(state, initialState())
    }
  },
  modules: {
    settings
  }
}
